// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Container from '../components/Match/Detail/Container';


@observer class MatchRoute extends Component<any, any> {
	render() {
		return (
			<Container id={this.props.match.params.id} key={this.props.match.params.id}/>
		)
	}
}

export default MatchRoute;

